import styled from 'styled-components';
export const FooterBlock = styled.div`
flex: 1;
width: 206px;


.footerHeading {
    font-size: 18px;
    color: #141823;
    font-family: quicksand;
    margin-bottom: 16px;
    font-weight: 700;
}
@media (max-width: 768px) {
    width: inherit;
    padding: 0 24px;
    .footerHeading {
        font-size: 14px;
        margin-bottom: 8px;
    }
}
`

export const FootInfo = styled.ul`
& li{
    margin-bottom: 12px;
    width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
& li a {
    color: #757575;
    font-size: 14px;
    color: #0084ff;
}
@media (max-width: 768px) {
    margin-bottom: 16px;
    & li {
        width: inherit;
        margin-bottom: 16px;  
    }
    & li a {
        font-size: 12px;
    }
}
`


export const FooterWrapper = styled.div`
background: #fff;
padding-top: 40px;
padding-bottom: 60px;

`

export const FooterContent = styled.div`
    width: 1280px;
    margin: 0 auto;
    flex-wrap: wrap;
    @media (max-width: 768px) {
        width: 100%;
        }
`


export const FooterSection = styled.div`
border-bottom: 1px solid #d8d8d8;
padding-bottom: 20px;
display: flex;
flex-direction: row;
    @media (max-width: 768px) {
        border-bottom: 0;
        padding-bottom: 20px;
        flex-direction: column;
        }
`
export const FollowUsSection= styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 20px 0;
    border-bottom: 1px solid #d8d8d8;
.flexOne{
    flex: 1;
}
.followTxt {
    color: #141823;
    font-size: 18px;
    font-family: quicksand;
    margin-bottom: 10px;
}
.makeFlex {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
}
.followIcons img {
    margin-right: 10px;
}
.bankInfo {
    justify-content: flex-end;
    display: flex;
}
.textCenter {
    text-align: center;
}

    @media (max-width: 768px) {
        display: none;
        }`


 export const AllRightSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 20px 0;
    & img {
        margin-right: 18px;
    }
    .flexOne{
        flex: 1;
    }
  
    .makeFlex {
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
    }
    .copyrightText{
        font-size: 12px;
    color: #777;
    text-align: right;
    }
    @media (max-width: 768px) {
        display: none;
}`
    
export const MobileHeaderContainer = styled.div`
    display:none;
    @media (max-width: 768px) {
        display: block;
}`
    
export const GoTribeThankYouPage = styled.div`
    @media (max-width: 768px) {
        margin:0 16px;
 }
`